import { render, staticRenderFns } from "./RePostedLifecycle.vue?vue&type=template&id=878a482c"
import script from "./RePostedLifecycle.vue?vue&type=script&lang=js"
export * from "./RePostedLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports